var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgPaymentLoader = function SvgPaymentLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#356B61",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M39 21.5C39 12.387 31.613 5 22.5 5S6 12.387 6 21.5 13.057 38 22.17 38"
  })));
};
var Memo = /*#__PURE__*/memo(SvgPaymentLoader);
export default Memo;